import useFormIndex from "../../support/useFormIndex";

export default () => ({
    mainEventId: Alpine.$persist('').as('mainEventId'),

    init() {
        if(this.mainEventId) {
            this.$store.customerImages.loadSavedPhotos(this.mainEventId);
        }

        window.addEventListener('cart::mainEvent', ({detail: mainEvent}) => {
            if(mainEvent[0].id !== this.mainEventId) {
                this.mainEventId = mainEvent[0].id;

                this.$store.customerImages.images = [];
                this.$store.customerImages.updateCount();

                this.$store.customerImages.loadSavedPhotos(mainEvent[0].id);
            }

            this.$nextTick(async () => {
                this.$wire.dispatch('customer::loadPackages');

                if (! useFormIndex()) {
                    return;
                }
            });
        });
    }
});
